<template>
  <Form class="commonForm" :ref="refName" :model="formModel"
    :style="{'overflow-y':'auto','overflow-x':'hidden'}" :rules="formRules"
     label-position="top">
     <Spin size="large" fix v-if="spinShow"></Spin>
    <Row >
 
       
      <Col span="24">
        <FormItem  
          :label="_vm.$t('devicelist.newpass')" 
          prop="pass">
            <Input v-model="formModel.pass" :placeholder="_vm.$t('devicelist.inputnewpass')" />
        </FormItem>
      </Col>
         
    </Row>
  </Form> 
</template>

<script>
import config from '@/config'
import {pests} from '@/api/api_url'
import {renderFormMixins} from '@/mixins/renderFormMixins'
import {get_type,catch_fear_timelist,deviceinfo_list} from '@/api/jingxiaoshang'
//import commonTitle from '@/view/console/components/commonTitle'

export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data () {
    return {
      show_desc:0,
      product_type_codeData: [],
      tableloading:false,
      modelcodeData:[],//数据
      protocol_typeData: [],
      inverter_typeData: [],
      path:[],
      reqBase:{},
      formModel: {
        pass: null,
        product_code:null
      },
      spinShow:false,
      formRules: {
       pass: [
          {required: true,message: this._vm.$t('devicelist.newpassnotnull'), trigger: 'blur'}
        ]
      },
      nodeList:[],
      tempData:{},//等待提交的临时数据
    }
  },
  props: {
    _vm: {},
    edit: {
      type:Boolean,
      default:false
    },
    
 hasDetails:{
        type:Boolean,
        default:false
      },
    $store: {},
    setData: {},
  
  },
  components: {
  },
  computed: {
    getAction(){
      let result = '';
      if (process.env.NODE_ENV === 'development') {
        result = config.baseUrl.dev + "" + pests.upload_file
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.baseUrl.pro + "" + pests.upload_file
      } else {
        result = config.baseUrl.alp + "" + pests.upload_file
      }
      return result;
    },
    projectCode(){
      return this.$store.state.user.projectCode
    }
  },
  methods: {
    change_radio(val) {
      //console.log("val",val)
      if (val == 1) {
        this.show_desc=0
      } else {
        this.show_desc=1
      }
    },
    get_type() {
      get_type({}).then(res => {
            let msg=res.errorMsg;
            if (res.result === 0) {
                let msg=res.errorMsg; 
            
              this.protocol_typeData = res.body.protocol_type
            
            } else {
              vm.$Message.error(msg); 
              _this.buttonLoading = false;
            }
          });
    },
   
    /**
     * 单个删除
     */
    delDevice(row){
      for(let i=0;i<this.data2.length;i++){
        let list=this.data2[i]
        if(row.device_id===list.device_id){
          //同时删除临时对象中的数据
          let index=this.tempData[list.node_code].indexOf(list.device_id)
          if(index>-1){
            this.tempData[list.node_code].splice(index,1)
          }
          this.data2.splice(i,1)
          break;
        }
      }
    },
    clickNode(data){
      this.data1.splice(0)
      this.tableloading=true;
      this.$set(this.reqBase,'page',1)
      this.$set(this.reqBase,'page_size',2000)
      this.$set(this.reqBase,'node_code',data.node_code)
      this.$set(this.reqBase,'project_code',this.projectCode)
      deviceinfo_list(this.reqBase).then(res=>{
        this.tableloading=false;
        if(res.result===0){
          let list=res.body.list || []
          this.data1.push(...list)
        }else{

        }
      })
    },
    addTimeFun(){
      this.$refs.addTime.showModal(true)
    },
    
    createTree(data){
      for(let i in data){
        let list=data[i]
        list['value']=list.cate_code
        list['label']=list.cate_name
        if(list.children && list.children.length>0){
          this.createTree(list.children)
        }
      }
    },
    getTreeNodeData(callback){
      this.spinShow=true;
      this.nodeList.splice(0)
      patrolcateGetAllCate({
        project_code:this._vm.$store.state.user.projectCode
      }).then(res=>{
        this.spinShow=false
        if(res.result===0){
          let data=res.body
          this.createTree(data)
          this.nodeList.push(...data)
          if(callback){
            callback(this.nodeList)
          }
        }else{

        }
        
      })
    },
    
    init () {
      
    },
    /**
     * 获取节点所在数组的位置
     */
    getTreeNodeArray(tree, func, path){
      if (!tree) return []
        for (const data of tree) {
          // 这里按照你的需求来存放最后返回的内容吧
          //这里的date是表示我是根据date去查询父级的，你可以修改成你的需求，其他不变
          path.push(data.node_code) 
          if (func(data)) 
            return path
          if (data.children) {
            const findChildren = this.getTreeNodeArray(data.children, func, path)
            if (findChildren.length) 
              return findChildren
          }
          path.pop()
        }
        return []
    },
    /**
     * 返回数据
     */
    setTimeRule(timeObj){
      this.$set(this.formModel.plan_interval,'plan_start',timeObj.plan_start)
      this.$set(this.formModel.plan_interval,'plan_end',timeObj.plan_end)
      this.$set(this.formModel.plan_interval,'interval',timeObj.interval)
      this.$set(this.formModel,'plan_accuracy',timeObj.plan_accuracy)
    }
  },
  mounted() {
   // this.get_type();
    this.$set(this.formModel, 'product_code', this.setData.product_code)
    this.$set(this.formModel,'pass',this.setData.pass)
   // console.log('ccc',this.setData) 
    // if (this.edit) { 
    // //  console.log('bbb',this.setData)
    //  if (this.setData) {
    //    Object.assign(this.formModel, this.setData)
    //   }
    // } else {
    //   //this.$set(this.formModel, 'product_type_code', this.product_type_code)
    //   //this.$set(this.formModel,'pass',this.pass)
    //  //this.$set(this.formModel,'model_codes',this.parent_code)
    // }
  },
  created () {
    
    // this.init()
  }
}
</script>

<style scoped>
  .commonForm /deep/ .ivu-form-item-label {
      text-align: left !important;
  }
  .demo-upload-list {
      display: inline-block;
      width: 60px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      border: 1px solid transparent;
      border-radius: 4px;
      overflow: hidden;
      background: #fff;
      position: relative;
      box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
      margin-right: 4px;
  }

  .demo-upload-list img {
      width: 100%;
      height: 100%;
  }

  .demo-upload-list-cover {
      display: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, .6);
  }

  .demo-upload-list:hover .demo-upload-list-cover {
      display: block;
  }

  .demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }

  .titleCol {
      text-align: center;
  }

  .uploadTip {
    font-size: 12px;
    margin-top: -10px;
    margin-bottom: 10px;
  }
  .contentImg{
    width: 500px;
  }
  .contentIcon{
    cursor:pointer
  }
  .layout50, .layout100 {
    margin-bottom: 15px;
  }

  .layout50 {
    width: calc(50% - 12px);
    padding-left: 8px;
    padding-right: 8px;
  }
  .classLayout{
    display: flex;
    flex-wrap: wrap;
    margin-left: -8px;
    margin-right: -8px;
  }
   .addLayout{
    text-align: left;
    margin-left:8px;
  }
  .uploadInner{
    position: relative;
  }
  .uploadDelIcon{
    position:absolute;
    top:5px;
    right:5px;
    z-index: 1111;
  }
  .bm-view {
    width: 100%;
    height: 300px;
  }
  .mapWrapper{
    position: relative;
  }
  .mapWrapper .inputContent{
    position: absolute;
    top:5px;
    left:0;
    z-index: 55;
    width:180px;
  }
  .addressLabel{
    display: inline-block;
    width: 100%;
    position: relative;
    vertical-align: middle;
    line-height: normal;
  }
  .noLabel{
    margin-top:30px;
  }
  .desc{color:#FF6060}
</style>
